module.exports = __webpack_public_path__ + "img/1f1dd8c57fc54d0f82999b86655ce159-1440.8f8e678a.jpg";